import { createContext } from 'react'

type ProducerModalContextType = {
  producerModalOpen: boolean
  setProducerModalOpen: (isModalOpen: boolean) => void
}

export const ProducerModalContext = createContext<ProducerModalContextType>({
  producerModalOpen: false,
  setProducerModalOpen: () => {}
})
